const REACT_APP_BFF_URL = process.env.REACT_APP_BFF_URL

// Get documents by role
export const getDocuments = async (token, role) => {
  const url = role ? `${REACT_APP_BFF_URL}/api/documents?role=${role}` : `${REACT_APP_BFF_URL}/api/documents`

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error("Error al obtener los documentos.")
  }

  const data = await response.json()

  // Mapear los datos para que coincidan con la estructura esperada por el componente
  return data.map((doc) => {
    // Asegurarse de que la fecha sea válida
    let uploadDate
    try {
      // Intentar crear un objeto Date válido
      uploadDate = doc.created_at ? new Date(doc.created_at) : null

      // Verificar si la fecha es válida
      if (uploadDate && isNaN(uploadDate.getTime())) {
        uploadDate = null
      }
    } catch (e) {
      console.error("Error parsing date:", e)
      uploadDate = null
    }

    return {
      id: doc.id,
      filename: doc.filename,
      description: doc.description,
      role: doc.role,
      uploadDate: uploadDate,
      status: "active", // Asumimos un estado por defecto
      file_path: doc.file_path, // This is now a GCS path instead of base64
    }
  })
}

// Upload a document
export const uploadDocument = async (token, formData) => {
  const response = await fetch(`${REACT_APP_BFF_URL}/api/documents/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  })

  if (!response.ok) {
    throw new Error("Error al subir el documento.")
  }

  return await response.json()
}

// Update a document
export const updateDocument = async (token, documentId, data) => {
  const response = await fetch(`${REACT_APP_BFF_URL}/api/documents/${documentId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    throw new Error("Error al actualizar el documento.")
  }

  return await response.json()
}

// Delete a document
export const deleteDocument = async (token, documentId) => {
  const response = await fetch(`${REACT_APP_BFF_URL}/api/documents/${documentId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error("Error al eliminar el documento.")
  }

  return await response.json()
}

// Get document download URL
export const getDocumentDownloadUrl = async (token, documentId) => {
  const response = await fetch(`${REACT_APP_BFF_URL}/api/documents/${documentId}/download`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error("Error al obtener la URL de descarga del documento.")
  }

  // The backend now returns a redirect to the signed URL
  return response.url
}

// Helper function to convert file to base64 (if needed)
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
